export enum CompFarmListViewType {
  Card = 'card',
  Table = 'table',
  Compare = 'compare',
}
